<template>
  <ul class="nav nav-mobile-menu">
    <li>
    <router-link :to="{name: 'Edit Profile'}" tag="a">
      <span class="sidebar-mini"><i class="fas fa-address-card"></i></span>
      <span class="sidebar-normal">My Profile</span>
    </router-link>
    </li>
  </ul>
</template>
<script>
  export default {}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/MobileMenu.vue